import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Header from '../Components/Header'
import Rightcontainer from '../Components/Rightcontainer'
import '../css/terms.css'
import { Interweave } from 'interweave'
import axios from 'axios'
const Terms_condition = () => {
  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {

    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++ 
  const [data, setData] = useState()
  const getdata = () => {

    axios
      .get(baseUrl + `api/term/condition/term-condition`)
      .then(res => {
        setData(res.data[0].Desc)
        // console.log(res.data[0].Type);
      })
  }
  useEffect(() => {
    getdata()
  }, [])
  return (
    <div>
      <div className='leftContainer mb_space'>
        <Header />
        <div className='mt-5 py-4 px-3'>
          <div className='m-3'>
            <h1 className='profile_headings' style={{ color: "black" }}>Terms &amp; Condition</h1>

            <h4 className='other_page_small_headings'>1. Terms and Conditions for SKILLSONOMY INFO PRIVATE LIMITED</h4> <br />
            <>
              <p className=' small_para'>
                These Terms and Conditions ("Terms") constitute a legally binding agreement between SKILLSONOMY INFO PRIVATE LIMITED ("SKILLSONOMY Ludo," "we," "us") and users ("you," "User") governing the use of our gaming platform ("Platform"), including all games, contests, and services (collectively, "Services"). By accessing the Platform, you agree to:
              </p>
              <p className=' small_para'>
                1.2. By accessing and/or using the Services, Users agree to be
                bound by these Terms and SKILLSONOMY INFO PRIVATE LIMITED
                Company
                Privacy Policy, as stated on paragraph 5.
              </p>
              <p className=' small_para'>
                1.3. Users state that they are of legal age (minimum 18 years of
                age) to access the Services and Content, or if legally possible,
                to access with their legal guardian consent, due authorization
                and agreement with these Terms.
              </p>

              These Terms;<br />

              Our Privacy Policy;<br />

              Game-specific rules.<br />
              <p className=' other_page_small_headings'>
                1. Eligibility::
              </p>
              <ul className='ul1'>
                <li className='li4 small_para'>
                  You must be at least 18 years old and a resident of India (except prohibited states: Assam, Odisha, Nagaland, Sikkim, Meghalaya, Andhra Pradesh, Telangana, Kerala, Gujarat).

                </li>
                <li className='li4 small_para'>
                  Residents of Gujarat/Kerala may only access free-to-play modes (no stakes).
                </li>
                <li className='li4 small_para'>
                  Employees of SKILLSONOMY INFO PRIVATE LIMITED or its affiliates are barred from paid contests.
                </li>
                <li className='li4 small_para'>
                  Prohibited Jurisdictions: Users from restricted states/countries must not participate in stakes-based contests. Violations may lead to account termination and legal action.
                </li>

              </ul>


              <p className='p3 other_page_small_headings'>2.  Services and Licenses</p>
              <p className=' small_para'>

                2.1. Limited License: We grant you a non-exclusive, revocable license to use our Platform for personal, non-commercial purposes.
              </p>
              <p className=' small_para'>
                2.2. Modifications: We may update, suspend, or discontinue Services without prior notice.
              </p>
              <p className=' small_para'>
                2.3. Third-Party Content: Links to external sites (e.g., YouTube) are governed by their respective policies.
              </p>



              <p className='p3 other_page_small_headings'>3.  User Obligations</p>
              <p className=' small_para'>
                Account Security:
              </p>
              <p className=' small_para'>
                You are responsible for safeguarding login credentials.
              </p>
              <p className=' small_para'>
                Notify us immediately of unauthorized access at support@SKILLSONOMY.com.
              </p>
              <p className=' small_para'>
                Prohibited Conduct:
              </p>
              <p className=' small_para'>
                No cheating, bots, or fraudulent activities.
              </p>
              <p className=' small_para'>
                No impersonation or multiple accounts.
              </p>

              <p className='p3 other_page_small_headings'>4. Contests and Payments</p>

              <p className=' small_para'>
                Stakes-Based Games
              </p>
              <p className=' small_para'>
                Only permitted in eligible states (excludes Assam, Odisha, etc.).
              </p>

              <p className=' small_para'>
                Ludo for stakes is banned in Kerala; Poker for stakes in Gujarat.
              </p>
              <p className=' small_para'>
                Deposits/Withdrawals:
              </p>
              <p className=' small_para'>
                All transactions are final unless required by law.
              </p>
              <p className=' small_para'>
                Refunds only for technical errors (subject to proof).
              </p>
              <ul className='ul1'>
                <li className='li4 small_para'>
                  Prizes & Levels:
                </li>
                <li className='li4 small_para'>
                  Virtual "Levels" have no monetary value and cannot be transferred/sold.
                </li>
                <li className='li4 small_para'>
                  Prize disputes are resolved at our sole discretion.
                </li>

              </ul>




              <p className='p3 other_page_small_headings'>5 Disclaimers and Liabilities</p>
              <p className=' small_para'>
                No Warranties: We do not guarantee uninterrupted or error-free Services.
              </p>
              <p className=' small_para'>
                Limitation of Liability: We are not liable for:
              </p>
              <p className=' small_para'>
                Losses due to User negligence (e.g., incorrect bank details).
              </p>
              <p className=' small_para'>
                Third-party actions (e.g., payment gateways).
              </p>


              <p className='p3 other_page_small_headings'>6. Termination and Disputes</p>
              <p className=' small_para'>
              Account Suspension: We may terminate accounts for breaches, fraud, or legal non-compliance.
              </p>
              <p className=' small_para'>
               Governing Law: Disputes shall be resolved under Indian law in Delhi courts.
              </p>
               
              
              <p className='p3 other_page_small_headings'>
                7. Tax &amp; TDS Policy
              </p>
              <p className=' small_para'>
                10.1. Any tax/levies/duty etc., as applicable, shall be paid by
                the user of the game of SKILLSONOMY INFO PRIVATE LIMITED
                Company Games.
              </p>
              <p className=' small_para'>
                10.2. There is no TDS deducted as the winning amounts are up to
                or less than Rs.10,000/- on SKILLSONOMY INFO PRIVATE LIMITED
                Company
                Games/Quiz.
              </p>
              <p className=' small_para'>
                10.3. TDS is deducted on winning amounts above Rs.10,000/- on
                SKILLSONOMY INFO PRIVATE LIMITED
                Company Games/Quiz before releasing
                the winnings prize/product/amount and/or in whatever name
                called.
              </p>
              <p className=' small_para'>
                10.4. Based on TDS (tax deducted at source) Rules for any sort
                of game winning in India, 30% TDS should be deducted on any
                wining above Rs.10,000/- in a single game.
              </p>
              <p className=' small_para'>
                10.6. The person responsible for paying shall, before releasing
                the winnings, collect the TDS amount from the winner.
              </p>
              <p className=' small_para'>
                10.7. Your prize can only be redeemable after TDS deduction , if
                winning product is above 10,000/- . TDS amount is to be paid to
                SKILLSONOMY INFO PRIVATE LIMITED
                Company Games as provided by Section
                194B read with Section 115BB of the Income Tax Act, 1961.
              </p>
              <p className=' small_para'>
                10.8. The User will have to provide his valid PAN card copy so
                that SKILLSONOMY INFO PRIVATE LIMITED
                Company Games can file TDS
                deducted accordingly.
              </p>
              <p className=' small_para'>
                10.9. TDS has to be paid within 24 hours. Kindly give us time
                period of 15 working days to deliver your prize.
              </p>
              <p className=' small_para'>
                10.10. To claim your winning product, if TDS as applicable by
                govt. (as per Section 194B read with Section 115BB of the Income
                Tax Act, 1961) on your winning, winner gets 24 hrs time to pay
                TDS from the time of winning to claim their prize. If user fails
                to pay TDS within 24 hrs his/her winning will be considered as
                expired.
              </p>
              <p className=' small_para'>
                10.11. SKILLSONOMY INFO PRIVATE LIMITED
                Company in the interests of
                clarity, performs an independent closing balance confirmation at
                the end of every year from its external wallet service providers
                (RazorPay, PayTM, Cash Free, etc.). In the event that there
                exists discrepancy between the accounts of the external wallet
                service providers and SKILLSONOMY INFO PRIVATE LIMITED
                CompanyGAMING
                PRIVATE LIMITED, SKILLSONOMY INFO PRIVATE LIMITED
                Company, in its sole
                discretion and authority, shall perform reasonable due diligence
                to ascertain the liability for the differences in the accounts.
              </p>
             
              <p className='p3 other_page_small_headings'>12. Payment Terms</p>
              <ul className='ul1'>
                <li className='li4 small_para'>
                  In respect of any transactions entered into on the SKILLSONOMY INFO PRIVATE LIMITED
                  Companyplatform, including making a payment to
                  participate in the paid versions of Contest(s), Users agree to
                  be bound by the following payment terms:
                  <ul className='ul1'>
                    <li className='li4 small_para'>
                      User's winnings can be credited in any wallet sub-section
                      (Deposits, Bonus, Winnings) in any proportion at LAVYANSHU
                      WEBTECH PRIVATE LIMITEDGAMING PRIVATE LIMITED's sole
                      discretion.
                    </li>
                    <li className='li4 small_para'>
                      User’s remitting the amount the designated payment gateway
                      shall be credited to User’s ‘Unplayed’ Account’.
                    </li>
                  </ul>
                </li>
                <ul className='ul1'>
                  <li className='li4 small_para'>
                    The payment of pre-designated amount Users make to
                    participate in the Contest(s) is inclusive of the
                    pre-designated platform fee (when applicable) for access to
                    the SKILLSONOMY INFO PRIVATE LIMITED
                    Company Services charged by
                    SKILLSONOMY INFO PRIVATE LIMITED
                    Company and pre-determined
                    participant’s contribution towards prize money pool.
                  </li>
                  <li className='li4 small_para'>
                    Subject to these Terms and Conditions, all amounts collected
                    from the User are held, until determination of the Winners
                    and distribution of prizes. LAVYANSHU WEBTECH PRIVATE
                    LIMITED receives only its share of the platform Fees,
                    subject to applicability.
                  </li>
                  <li className='li4 small_para'>
                    The User may participate in a Contest wherein the User has
                    to contribute a pre-specified contribution towards the Prize
                    Money Pool of such Contest, which will be passed on to the
                    Winner(s) of the Contest after the completion of the Contest
                    as per the terms and conditions of such Contest. It is
                    clarified that SKILLSONOMY INFO PRIVATE LIMITED
                    Company has no
                    right or interest in this Prize Money Pool, and only acts as
                    an intermediary engaged in collecting and distributing the
                    Prize Money Pool in accordance with the Contest terms and
                    conditions. The amount to be paid-in by the User towards the
                    Prize Money Pool would also be debited from the User’s
                    account balance.
                  </li>
                  <li className='li4 small_para'>
                    Any user availing SKILLSONOMY INFO PRIVATE LIMITED
                    Company services
                    are provided with two categories of accounts for the
                    processing and reconciliation of payments: (i) ‘Unplayed’
                    Account, (ii) Winnings Account. It is clarified that in no
                    instance the transfer of any amounts in the User's accounts
                    to any other category of account held by the user or any
                    third party account, including a bank account held by a
                    third party:
                  </li>
                  <li className='li4 small_para'>
                    Each time a User participates in any contest on LAVYANSHU
                    WEBTECH PRIVATE LIMITEDplatform, the pre-designated amount
                    shall be debited in the User’s account. In debiting amounts
                    from the User’s accounts towards the pre-designated amount
                    of such user shall be debited from the User’s Unplayed
                    Account and thereafter, any remaining amount of
                    participation fee shall be debited from the User’s Winning
                    Account.
                  </li>
                  <li className='li4 small_para'>
                    In case there is any amount remaining to be paid by the User
                    in relation to such User’s participation in any match(s) or
                    Contest(s), the User will be taken to the designated payment
                    gateway to give effect to such payment. In case any amount
                    added by the User through such payment gateway exceeds the
                    remaining amount of the pre-designated amount, the amount in
                    excess shall be transferred to the User’s ‘Unplayed’ Account
                    and will be available for use in participation in any
                    match(s) or Contest(s) or for withdrawal in accordance with
                    these Terms and Conditions.
                  </li>
                  <li className='li4 small_para'>
                    Debits from the ‘Unplayed’ Account for the purpose of
                    enabling a user’s participation in a Contest shall be made
                    in order of the date of credit of amounts in the ‘Unplayed’
                    Account, and accordingly amounts credited into ‘Unplayed’
                    Account earlier in time shall be debited first.
                  </li>
                  <li className='li4 small_para'>
                    A User shall be permitted to withdraw any amounts credited
                    into such User's ‘Unplayed’ Account for any reason
                    whatsoever by contacting SKILLSONOMY INFO PRIVATE LIMITED
                    Company
                    Customer Support. All amounts credited into a User's
                    ‘Unplayed’ Account must be utilised within 60 days of
                    credit. In case any unutilised amount lies in the ‘Unplayed’
                    Account after the completion of 60 days from the date of
                    credit of such amount, SKILLSONOMY INFO PRIVATE LIMITED
                    Company
                    reserves the right to forfeit such unutilized amount,
                    without liability or obligation to pay any compensation to
                    the User. Users are requested to note that they will be
                    required to provide valid photo identification and address
                    proof documents for proof of identity and address in order
                    for SKILLSONOMY INFO PRIVATE LIMITED
                    Company to process the
                    withdrawal request. The name mentioned on the User's photo
                    identification document should correspond with the name
                    provided by the User at the time of registration on
                    SKILLSONOMY INFO PRIVATE LIMITED
                    Company, as well as the name and
                    address existing in the records of the User's bank account
                    as provided to SKILLSONOMY INFO PRIVATE LIMITED
                    Company. In the
                    event that no bank account has been registered by the User
                    against such User's account with LAVYANSHU WEBTECH PRIVATE
                    LIMITED, or the User has not verified his/her User account
                    with SKILLSONOMY INFO PRIVATE LIMITED
                    Company, to LAVYANSHU WEBTECH
                    PRIVATE LIMITEDGAMING PRIVATE LIMITED's satisfaction and in
                    accordance with these Terms and Conditions, LAVYANSHU
                    WEBTECH PRIVATE LIMITED shall provide such User with a
                    notification to the User's email address as on record with
                    SKILLSONOMY INFO PRIVATE LIMITED
                    Company at least 30 days prior to
                    the Request Date, and in case the User fails to register a
                    bank account with his/her User Account and/or to verify
                    his/her User Account by the Request date, LAVYANSHU WEBTECH
                    PRIVATE LIMITED shall be entitled to forfeit any amounts
                    subject to transfer. Failure to provide LAVYANSHU WEBTECH
                    PRIVATE LIMITEDwith a valid bank account or valid
                    identification documents (to LAVYANSHU WEBTECH PRIVATE
                    LIMITED's satisfaction) may result in the forfeiture of any
                    amounts subject to transfer in accordance with this clause.
                  </li>
                  <li className='li4 small_para'>
                    Withdrawal of any amount standing to the User's credit in
                    the Winnings Account may be made by way of a request to
                    SKILLSONOMY INFO PRIVATE LIMITED
                    CompanyGAMING PRIVATE LIMITED but
                    the amount will be forfeit upon completion of 60 days from
                    the date of credit of such amount in the User's Winnings
                    Account or upon completion of 60 days of in-activity.
                  </li>
                  <li className='li4 small_para'>
                    Further, in order to conduct promotional activities,
                    SKILLSONOMY INFO PRIVATE LIMITED
                    Companymay gratuitously issue
                    Bonus points (Called as Cash Bonus) to the User for the
                    purpose of participation in any Contest(s) and no User shall
                    be permitted to transfer or request the transfer of any
                    amount in to the Cash Bonus . The usage of any points issued
                    shall be subject to the limitations and restrictions,
                    including without limitation, restrictions as to time within
                    which such points must be used, as applied by LAVYANSHU
                    WEBTECH PRIVATE LIMITED and notified to the User at the time
                    of issue of such amount. The issue of any points to the user
                    is subject to the sole discretion of LAVYANSHU WEBTECH
                    PRIVATE LIMITEDand cannot be demanded by any User as a
                    matter of right. The issue of any such amount by LAVYANSHU
                    WEBTECH PRIVATE LIMITED on any day shall not entitle the
                    user to demand the issuance of such amount at any subsequent
                    period in time nor create an expectation of recurring issue
                    of such amount by SKILLSONOMY INFO PRIVATE LIMITED
                    Company to such
                    User. The bonus points/Cash Bonus granted to the user may be
                    used by such User for the purpose of setting off against the
                    contribution to prize pool in any Contest, in accordance
                    with these Terms and Conditions. The bonus points shall not
                    be withdraw-able or transferrable to any other account of
                    the User, including the bank account of such User, or of any
                    other User or person, other that as part of the winnings of
                    a User in any Contest(s). In case the User terminates
                    his/her account with SKILLSONOMY INFO PRIVATE LIMITED
                    Company or
                    such account if terminated by LAVYANSHU WEBTECH PRIVATE
                    LIMITED, all bonus points granted to the user shall return
                    to SKILLSONOMY INFO PRIVATE LIMITED
                    Company and the User shall not
                    have any right or interest on such points.
                  </li>
                  <li className='li4 small_para'>
                    All cash bonus credited in the User account shall be valid
                    for a period of 14 days from the date of credit. The cash
                    bonus shall lapse at the end of 14 days and the cash bonus
                    amount shall not reflect in the User account.
                  </li>
                  <li className='li4 small_para'>
                    Users agree that once they confirm a transaction on
                    SKILLSONOMY INFO PRIVATE LIMITED
                    CompanyGAMING PRIVATE LIMITED,
                    they shall be bound by and make payment for that
                    transaction.
                  </li>
                  <li className='li4 small_para'>
                    The User acknowledges that subject to time taken for bank
                    reconciliations and such other external dependencies that
                    SKILLSONOMY INFO PRIVATE LIMITED
                    Company has on third parties, any
                    transactions on SKILLSONOMY INFO PRIVATE LIMITED
                    Company Platform
                    may take up to 24 hours to be processed. Any amount paid or
                    transferred into the User's ‘Unplayed’ Account or Winnings
                    Account may take up to 24 hours to reflect in the User's
                    ‘Unplayed’ Account or Winnings Account balance. Similarly,
                    the utilization of the bonus points or money debited from
                    ‘Unplayed’ Account or Winnings Account may take up to 24
                    hours to reflect in the User's ‘Unplayed’ Account or
                    Winnings Account balance. Users agree not to raise any
                    complaint or claim against SKILLSONOMY INFO PRIVATE LIMITED
                    Company
                    in respect of any delay, including any lost opportunity to
                    join any Contest or match due to delay in crediting of
                    transaction amount into any of the User's accounts.
                  </li>
                  <li className='li4 small_para'>
                    A transaction, once confirmed, is final and no cancellation
                    is permissible. SKILLSONOMY INFO PRIVATE LIMITED
                    Company may, in
                    certain exceptional circumstances and at its sole and
                    absolute discretion, refund the amount to the User after
                    deducting applicable cancellation charges and taxes. At the
                    time of the transaction, Users may also be required to take
                    note of certain additional terms and conditions and such
                    additional terms and conditions shall also govern the
                    transaction. To the extent that the additional terms and
                    conditions contain any clause that is conflicting with the
                    present terms and conditions, the additional terms and
                    conditions shall prevail.
                  </li>
                  <li className='li4 small_para'>
                    The real money added by the User on LAVYANSHU WEBTECH
                    PRIVATE LIMITED will solely be applied towards the rights
                    provided to you, by the Company, to play any game/s. Such
                    amount will be completely non-refundable and
                    non-transferrable and can only and only be
                    utilised&nbsp;towards the playing of games on LAVYANSHU
                    WEBTECH PRIVATE LIMITEDGAMING PRIVATE LIMITED. The
                    T&amp;C&nbsp;of each game would be displayed, along with the
                    fixed/ variable winnings amount which the User may win on
                    participation and successful completion of the terms of the
                    game. Such amounts will be decided by the Company for each
                    game separately. The User would be eligible to withdraw only
                    to the extent of their winnings (before that expires) and
                    after submission of relevant documentation to the Company.
                  </li>
                </ul>
                <li className='li4 small_para'>
                  <strong>Miscellaneous</strong>
                </li>
                <ul className='ul1'>
                  <li className='li4 small_para'>
                    The decision of SKILLSONOMY INFO PRIVATE LIMITED
                    Company with
                    respect to the awarding of prizes shall be final, binding
                    and non-contestable.
                  </li>
                  <li className='li4 small_para'>
                    The final assessment of wins by a User shall be determined
                    at the time of withdrawal of Wins, which will be subject to
                    applicable direct and indirect taxes. The withdrawal of Wins
                    shall be subject to applicable TDS as per the provisions of
                    the Income Tax Act (as described under
                    <strong>&nbsp;Tax and TDS Policy</strong>)
                  </li>
                  <li className='li4 small_para'>
                    Participants playing the paid formats of the Contest(s)
                    confirm that they are not residents of any of the following
                    Indian states - Assam, Odisha, Nagaland, Sikkim, Meghalaya,
                    Andhra Pradesh, or Telangana. If it is found that a
                    Participant playing the paid formats of the Contest(s) is a
                    resident of any of the abovementioned states, LAVYANSHU
                    WEBTECH PRIVATE LIMITEDshall disqualify such Participant and
                    forfeit any prize won by such Participant. Further LAVYANSHU
                    WEBTECH PRIVATE LIMITED may, at its sole and absolute
                    discretion, suspend or terminate such Participant's account
                    with SKILLSONOMY INFO PRIVATE LIMITED
                    Company. Any amount remaining
                    unused in the User's Game Account or Winnings Account on the
                    date of deactivation or deletion shall be reimbursed to the
                    User by an online transfer to the User's bank account on
                    record with SKILLSONOMY INFO PRIVATE LIMITED
                    Company, subject to
                    the processing fee (if any) applicable on such transfers as
                    set out herein.
                  </li>
                  <li className='li4 small_para'>
                    If it is found that a Participant playing the paid formats
                    of the Contest(s) is under the age of eighteen (18),
                    SKILLSONOMY INFO PRIVATE LIMITED
                    Companyshall be entitled, at its
                    sole and absolute discretion, to disqualify such Participant
                    and forfeit his/her prize. Further, LAVYANSHU WEBTECH
                    PRIVATE LIMITED may, at its sole and absolute discretion,
                    suspend or terminate such Participant's account.
                  </li>
                  <li className='li4 small_para'>
                    To the extent permitted by law, LAVYANSHU WEBTECH PRIVATE
                    LIMITED makes no representations or warranties as to the
                    quality, suitability or merchantability of any prizes and
                    shall not be liable in respect of the same.
                  </li>
                  <li className='li4 small_para'>
                    SKILLSONOMY INFO PRIVATE LIMITED
                    Company may, at its sole and
                    absolute discretion, vary or modify the prizes being offered
                    to winners. Participants shall not raise any claim against
                    SKILLSONOMY INFO PRIVATE LIMITED
                    Companyor question its right to
                    modify such prizes being offered, prior to closure of the
                    Contest.
                  </li>
                  <li className='li4 small_para'>
                    SKILLSONOMY INFO PRIVATE LIMITED
                    Company will not bear any
                    responsibility for the transportation or packaging of prizes
                    to the respective winners. SKILLSONOMY INFO PRIVATE LIMITED
                    Company
                    shall not be held liable for any loss or damage caused to
                    any prizes at the time of such transportation.
                  </li>
                  <li className='li4 small_para'>
                    The Winners shall bear the shipping, courier or any other
                    delivery cost in respect of the prizes.
                  </li>
                  <li className='li4 small_para'>
                    The Winners shall bear all transaction charges levied for
                    delivery of cash prizes.
                  </li>
                  <li className='li4 small_para'>
                    All prizes are non-transferable and non-refundable. Prizes
                    cannot be exchanged / redeemed for cash or kind. No cash
                    claims can be made in lieu of prizes in kind.
                  </li>
                </ul>
              </ul>
              <p className=' small_para other_page_small_headings'>
                12.1. Release and Limitations of Liability
              </p>
              <ul className='ul1'>
                <li className='li4 small_para'>
                  Users shall access the SKILLSONOMY INFO PRIVATE LIMITED
                  Company
                  Services provided on SKILLSONOMY INFO PRIVATE LIMITED
                  Company
                  voluntarily and at their own risk. SKILLSONOMY INFO PRIVATE LIMITED
                  Company shall, under no circumstances be held responsible or
                  liable on account of any loss or damage sustained (including
                  but not limited to any accident, injury, death, loss of
                  property) by Users or any other person or entity during the
                  course of access to the SKILLSONOMY INFO PRIVATE LIMITED
                  Company
                  Services (including participation in the Contest(s)) or as a
                  result of acceptance of any prize.
                </li>
                <li className='li4 small_para'>
                  By entering the contests and accessing the SKILLSONOMY INFO PRIVATE LIMITED
                  Company provided therein, Users hereby
                  release from and agree to indemnify SKILLSONOMY INFO PRIVATE LIMITED
                  Company, and/ or any of its directors, employees, partners,
                  associates and licensors, from and against all liability,
                  cost, loss or expense arising out their access to the
                  SKILLSONOMY INFO PRIVATE LIMITED
                  Company Services including (but not
                  limited to) personal injury and damage to property and whether
                  direct, indirect, consequential, foreseeable, due to some
                  negligent act or omission on their part, or otherwise.
                </li>
                <li className='li4 small_para'>
                  SKILLSONOMY INFO PRIVATE LIMITED
                  Company accepts no liability,
                  whether jointly or severally, for any errors or omissions,
                  whether on behalf of itself or third parties in relation to
                  the prizes.
                </li>
                <li className='li4 small_para'>
                  Users shall be solely responsible for any consequences which
                  may arise due to their access of SKILLSONOMY INFO PRIVATE LIMITED
                  Company Services by conducting an illegal act or due to
                  non-conformity with these Terms and Conditions and other rules
                  and regulations in relation to SKILLSONOMY INFO PRIVATE LIMITED
                  Company Services, including provision of incorrect address or
                  other personal details. Users also undertake to indemnify
                  SKILLSONOMY INFO PRIVATE LIMITED
                  Company and their respective
                  officers, directors, employees and agents on the happening of
                  such an event (including without limitation cost of attorney,
                  legal charges etc.) on full indemnity basis for any
                  loss/damage suffered by SKILLSONOMY INFO PRIVATE LIMITED
                  Company on
                  account of such act on the part of the Users.
                </li>
                <li className='li4 small_para'>
                  Users shall indemnify, defend, and hold LAVYANSHU WEBTECH
                  PRIVATE LIMITED harmless from any third
                  party/entity/organization claims arising from or related to
                  such User's engagement with the SKILLSONOMY INFO PRIVATE LIMITED
                  Companyor participation in any Contest. In no event shall
                  SKILLSONOMY INFO PRIVATE LIMITED
                  Company be liable to any User for
                  acts or omissions arising out of or related to User's
                  engagement with the SKILLSONOMY INFO PRIVATE LIMITED
                  Company or
                  his/her participation in any Contest(s).
                </li>
                <li className='li4 small_para'>
                  In consideration of SKILLSONOMY INFO PRIVATE LIMITED
                  Company allowing
                  Users to access the SKILLSONOMY INFO PRIVATE LIMITED
                  Company
                  Services, to the maximum extent permitted by law, the Users
                  waive and release each and every right or claim, all actions,
                  causes of actions (present or future) each of them has or may
                  have against SKILLSONOMY INFO PRIVATE LIMITED
                  Company, its respective
                  agents, directors, officers, business associates, group
                  companies, sponsors, employees, or representatives for all and
                  any injuries, accidents, or mishaps (whether known or unknown)
                  or (whether anticipated or unanticipated) arising out of the
                  provision of SKILLSONOMY INFO PRIVATE LIMITED
                  Company Services or
                  related to the Contests or the prizes of the Contests.
                </li>
              </ul>
              <p className=' small_para other_page_small_headings'>
                12.2. Standard Terms and Conditions of Promotions
              </p>
              <p className=' small_para'>
                These standard terms and conditions of promotions (“Standard
                Terms”) supplement the terms of promotions undertaken on the
                SKILLSONOMY INFO PRIVATE LIMITED
                Company website and which reference
                these Standard Terms (each a “Promotion”):
              </p>
              <ul className='ul1'>
                <li className='li4 small_para'>
                  Participation in any Promotion will be subject to a user
                  complying with the Promotion Terms implemented by SKILLSONOMY INFO PRIVATE LIMITED
                  Company in respect of such Promotion
                  (“Promotion Terms”) and these Standard Terms. By participating
                  in any Promotion, the participant further consents to and
                  agrees to adhere with the terms and conditions of the
                  SKILLSONOMY INFO PRIVATE LIMITED
                  Companygame and LAVYANSHU WEBTECH
                  PRIVATE LIMITED’s privacy policy.
                </li>
                <li className='li4 small_para'>
                  The Promotions are only open to users in India. Participation
                  in the Promotions by proxy is not permitted.
                </li>
                <li className='li4 small_para'>
                  Participation in the Promotions is voluntary.
                </li>
                <li className='li4 small_para'>
                  Participation in one Promotion does not guarantee that such
                  user will be eligible to participate in another Promotion.
                </li>
                <li className='li4 small_para'>
                  A user may participate in a Promotion and avail of each
                  Promotion only through one account. An existing user of
                  SKILLSONOMY INFO PRIVATE LIMITED
                  Company shall not register a new
                  account or operate more than one user account with SKILLSONOMY INFO PRIVATE LIMITED
                  Company or participate in a Promotion by
                  registering a new account.
                </li>
                <li className='li4 small_para'>
                  Users intending to participate in a Promotion may be required
                  to verify their mobile number and other account details in
                  accordance with the Promotion Terms for such Promotion.
                </li>
                <li className='li4 small_para'>
                  Persons intending to participate in a Promotion, who have
                  listed their phone numbers on the National Do Not Call
                  Registry (“NDNC Registry”), shall de-register themselves from
                  the NDNC Registry till the completion of such Promotion
                  (including the delivery of Bonus Amount (if any) or the
                  free-entry (if any) under such Promotion). Such persons agree
                  not to make any claim or raise any complaint whatsoever
                  against SKILLSONOMY INFO PRIVATE LIMITED
                  Companyin this respect.
                  Please note that persons intending to participate in a
                  Promotion who have not de-registered themselves from the NDNC
                  Registry shall also have no right to make any claim or raise
                  any complaints against SKILLSONOMY INFO PRIVATE LIMITED
                  Company if
                  they do or do not receive any call or SMS with respect to
                  their participation and all other matters pertaining to a
                  Promotion.
                </li>
                <li className='li4 small_para'>
                  The verification process may require you to submit personal
                  information about yourself. You agree to receive communication
                  from SKILLSONOMY INFO PRIVATE LIMITED
                  Company. Any information
                  collected in respect of your identity and contact details as
                  part of a Promotion or otherwise in the course of your use of
                  the SKILLSONOMY INFO PRIVATE LIMITED
                  Company Website shall be subject
                  to SKILLSONOMY INFO PRIVATE LIMITED
                  Company’s Privacy Policy.
                </li>
                <li className='li4 small_para'>
                  SKILLSONOMY INFO PRIVATE LIMITED
                  Company may, at its sole and
                  absolute discretion, disqualify any user from a Promotion if
                  such user engages in or it is found that such user has engaged
                  in any illegal, unlawful or improper conduct (with regard to
                  any of the Promotions or otherwise).
                </li>
                <li className='li4 small_para'>
                  The Bonus Amount (if any) deposited into the user’s account
                  can be used to join cash contests and contests on SKILLSONOMY INFO PRIVATE LIMITED
                  Company. However, the Bonus Amount (if any)
                  cannot be: (i) used to join 2-member contests; or (ii)
                  withdrawn or transferred to any other cash balance account
                  held by you with SKILLSONOMY INFO PRIVATE LIMITED
                  Company or to any
                  third party account or to any bank/payment instrument account.
                  THE BONUS AMOUNT (IF ANY) SHALL EXPIRE AND BE WITHOUT EFFECT
                  AT THE END OF FOURTEEN DAYS FROM THE DATE OF CREDIT OF THE
                  BONUS AMOUNT (IF ANY).
                </li>
                <li className='li4 small_para'>
                  The deposit of the Bonus Amount (if applicable) or the grant
                  of the free-entry (if any) shall be at the sole discretion of
                  SKILLSONOMY INFO PRIVATE LIMITED
                  Companyand shall be subject to the
                  user’s compliance with these Standard Terms and the applicable
                  Promotion Terms. SKILLSONOMY INFO PRIVATE LIMITED
                  Companymay
                  substitute or change the Bonus Amount(if any) or free-entry
                  (if any) offered under a Promotion at any time without notice.
                  Users may not substitute Bonus Amount (if any) or free-entry
                  (if any) for other items or exchange for cash.
                </li>
                <li className='li4 small_para'>
                  SKILLSONOMY INFO PRIVATE LIMITED
                  Company reserves the right to
                  withhold or forfeit the benefits of a Promotion (including a
                  free-entry or Bonus Amount due to a participant or any
                  prizes/winnings earned by the participant by using such
                  benefits) in the event that it determines or reasonably
                  believes that the participating user has violated these
                  Standard Terms, the applicable Promotion Terms or the terms
                  and conditions of the SKILLSONOMY INFO PRIVATE LIMITED
                  Company
                  fantasy game(s).
                </li>
                <li className='li4 small_para'>
                  Mere participation in a Promotion does not entitle the
                  participant to receive any free-entry or Bonus Amount(s)
                  indicated as a prize under such Promotion.
                </li>
                <li className='li4 small_para'>
                  The decision of SKILLSONOMY INFO PRIVATE LIMITED
                  Company will be
                  final and binding with respect to the Promotions, and the
                  prizes therein and no correspondence, objection, complaints,
                  etc. will be entertained in this regard.
                </li>
                <li className='li4 small_para'>
                  Each Promotion cannot be clubbed with any of other
                  contest/offer/promotion that are running simultaneously and
                  organised or conducted by SKILLSONOMY INFO PRIVATE LIMITED
                  Company.
                </li>
                <li className='li4 small_para'>
                  SKILLSONOMY INFO PRIVATE LIMITED
                  Company reserves the right to
                  change/modify/or withdraw any of the Promotions and/or change
                  these Standard Terms and/or the Promotion Terms without any
                  prior notice of the same at its sole discretion.
                </li>
                <li className='li4 small_para'>
                  SKILLSONOMY INFO PRIVATE LIMITED
                  Company does not make any
                  commitment, express or implied, to respond to any feedback,
                  suggestion and, or, queries of the participants of the
                  Promotions.
                </li>
                <li className='li4 small_para'>
                  Notwithstanding anything contained herein, the aggregate
                  liability of SKILLSONOMY INFO PRIVATE LIMITED
                  Company to a
                  participating user in relation to any Promotion for any reason
                  whatsoever shall not exceed Rs. 50.
                </li>
                <li className='li4 small_para'>
                  The Promotions shall be governed by the laws of the Republic
                  of India, and any disputes or disagreements in respect of this
                  Promotion shall be subject to the exclusive jurisdiction of
                  the courts of Delhi.
                </li>
              </ul>
            
            </>
          </div>
        </div>
      </div>
      <div className='rightContainer'>
        <Rightcontainer />
      </div>
    </div>
  )
}
export default Terms_condition
